import { useGetBusinessDetailsQuery } from "types/generated/operations";
import BusinessDetails from "./BusinessDetails";
import { getProspectUuid } from "utils/idHelpers";
import Loader from "uicomponents/Loader";
import Error from "uicomponents/Error";
interface IBusinessDetailsProps {
  setNextStep: () => void;
  setPreviousStep: () => void;
}

const BusinessDetailsModel = ({ ...props }: IBusinessDetailsProps) => {
  const { data, error, loading } = useGetBusinessDetailsQuery({
    variables: { uuid: getProspectUuid() },
    fetchPolicy: "no-cache",
  });
  if (loading) {
    return <Loader />;
  }
  if (error) {
    return <Error />;
  }
  return (
    <BusinessDetails
      setNextStep={props.setNextStep}
      data={data?.prospect}
      setPreviousStep={props.setPreviousStep}
    />
  );
};

export default BusinessDetailsModel;
